import { memo } from 'react'
import { propsAreEqual } from '../../../utils/questionnaireUtils'
import QuestionCardFooter from '../BasicQuestion/QuestionCardFooter/QuestionCardFooter'

export default memo(QuestionCardFooter, propsAreEqual)
